import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"20px","white-space":"nowrap"},
  class: "fas fa-info-circle"
}, null, -1)
const _hoisted_2 = { style: {"text-align":"justify"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 col-lg-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "col-12 col-lg-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "row justify-content-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "row justify-content-center" }
const _hoisted_15 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageContainer = _resolveComponent("ImageContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h5", null, [
      _hoisted_1,
      _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.See pic & write vocab")), 1)
    ]),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("messages.write word from picture")), 1),
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("form", {
      autocomplete: "off",
      id: "form",
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.checkWrite && _ctx.checkWrite(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_ImageContainer, {
            "image-url": _ctx.translation.imageUrl,
            description: _ctx.translation.imageDescription
          }, null, 8, ["image-url", "description"])
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              ref: "inputField",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.guessInput = $event)),
              style: {"width":"50%"}
            }, null, 512), [
              [_vModelText, _ctx.guessInput]
            ])
          ]),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", _hoisted_15, [
              _createTextVNode(_toDisplayString(_ctx.$t("messages.check answer")) + " ", 1),
              _hoisted_16
            ])
          ])
        ])
      ])
    ], 32)
  ], 64))
}